var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666",
    transform: "translate(-307 -420)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 44,
    height: 44,
    rx: 4,
    transform: "translate(307 420)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(319 432)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M12.963,16.667H3.7a3.7,3.7,0,0,1-3.7-3.7v-.926a.926.926,0,1,1,1.852,0v.926A1.852,1.852,0,0,0,3.7,14.815h9.259a1.852,1.852,0,0,0,1.852-1.852v-.926a.926.926,0,1,1,1.852,0v.926a3.7,3.7,0,0,1-3.7,3.7Zm-4.63-3.7a.923.923,0,0,1-.647-.263h0l0,0h0l0,0-3.7-3.7A.926.926,0,0,1,5.284,7.679L7.407,9.8V.926a.926.926,0,1,1,1.852,0V9.8l2.123-2.123a.926.926,0,0,1,1.309,1.309l-3.7,3.7,0,0h0l0,0h0l-.031.029a.92.92,0,0,1-.255.162h0a.922.922,0,0,1-.359.072Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/downloadPdf.738f0d12cccb54466c3c9890e0088a66.svg";
export { ForwardRef as ReactComponent };